<template>
  <vue-select
    style="width: 100%"
    :value="value"
    @search="getOptions"
    id="product-name-id"
    :options="$store.state.productsearch.product_search"
    label="name"
    class="select-x"
    placeholder="cari berdasarkan kata kunci"
    @input="changed"
  />
</template>

<script>
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { convertObjToString } from "../lib/helpers";

export default {
  components: {
    VueSelect,
  },
  name: "ProductNameSelector",
  props: ["value", "query"],
  created () {
    this.$store.dispatch('get_product_search', '')
  },
  methods: {
    init (q) {
      var qAdd = `q=${q}`;
      if (this.query) {
        qAdd += "&" + convertObjToString(this.query);
      }
      this.$store.dispatch('get_product_search', qAdd)
    },
    getOptions (search, loading) {
      loading(true);
      this.init(search);
      loading(false);
    },
    changed (evt) {
      this.$emit("input", evt);
    },
  },
};
</script>

<style scoped>
</style>
